import * as types from './constants';
import * as api from '../_api'

const getClasses = ({ commit }) => {
    api.fetchClasses
        .then((response) => {
            commit(types.GET_CLASSES, response.data)
        }).catch()
};

const setParamSearchLesson = ({ commit }, data) => {
    commit(types.SET_PARAMS_SEARCH_LESSONS, data)
}

const setBookIdActiveSuccess = ({ commit }, data) => {
    commit(types.HANDLE_ACTICE_BOOK_SUCCESS, data)
}

const acSetParamFilterBook = ({ commit }, data) => {
    commit(types.SET_PARAMS_FILTER_BOOK, data)
}

const acSetParamFilterBookLesson = ({ commit }, data) => {
    commit(types.SET_PARAMS_FILTER_BOOK_LESSON, data)
}

const acSetParamActiveLearning = ({ commit }, data) => {
    commit(types.SET_PARAMS_ACTIVE_LEARNING, data)
}

const acResetBookFilterLib = ({commit}, data) => {
	commit(types.SET_BOOK_LESSON_FILTER_RESULT, [])
	commit(types.SET_BOOK_PAGE_LINK_FILTER_RESULT, [])
}

const acGetBookOfPageLinks = ({ commit }, params) => {
	return api.getBookFilterPageLinks(params).then(res => {
        let result = res.list ? res.list : []
		!params.scrollData && commit(types.SET_BOOK_PAGE_LINK_FILTER_RESULT, result)
        return res
	})
}

const acGetBookOfLessons = ({ commit }, params) => {
	return api.getBookFilterLesson(params).then(res => {
        let result = res.list ? res.list : []
		!params.scrollData && commit(types.SET_BOOK_LESSON_FILTER_RESULT, result)
        return res
	})
}

const acGetBookActiveLearning = ({ commit }, params) => {
	// return api.getBookFilterPageLinks(params).then(res => {
	return api.getListBookActiveLearning(params).then(res => {
        let result = res.list ? res.list : []
		!params.scrollData && commit(types.SET_BOOK_ACTIVE_LEARNING, result)
        return res
	})
}

const acResetInitialState = ({ commit }, state) => {
    commit(types.RESET_STATE, state)
}

const actionSetValueListAtvLearn = ({ commit }, state) => {
    commit(types.SET_BOOK_ACTIVE_LEARNING, state)
}

export default {
    getClasses,
    setParamSearchLesson,
    setBookIdActiveSuccess,
    acSetParamFilterBook,
    acSetParamFilterBookLesson,
    acGetBookOfPageLinks,
    acGetBookOfLessons,
    acResetBookFilterLib,
    acResetInitialState,
    acSetParamActiveLearning,
    acGetBookActiveLearning,
    actionSetValueListAtvLearn
};